import{j as r}from"./chunk-GEPA7FLG.js";r();import{gql as e}from"@apollo/client";var n=e`
  mutation harvestNftFarm(
    $sender: String!
    $groupId: String!
    $farmAddress: String!
    $payWithEgld: Boolean!
  ) {
    transactions: harvestNftFarm(
      sender: $sender
      groupId: $groupId
      farmAddress: $farmAddress
      payWithEgld: $payWithEgld
    ) {
      nonce
      value
      sender
      receiver
      gasPrice
      gasLimit
      data
      chainID
      version
      options
    }
  }
`;export{n as a};
//# sourceMappingURL=chunk-XJDDDF3M.js.map
